import React, { Component } from "react";
import axios from "axios";
import { ValidateEmail, axiosConfig, normalize } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import { listUserRoles, addSubUserRoles } from "./../../../config/api_calls";
import {
  listAssignedUserPermissions,
  updateAssignedUserPermissions,
} from "../../../config/general_api_calls";

import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";

import TextField from "../../../components/InputFields/TextField";
import SelectField from "../../../components/InputFields/SelectField";
import MutextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import StepWizard from "react-step-wizard";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Editor } from "@tinymce/tinymce-react";

const auth = new HelperClass();

class Adduser extends Component {
  constructor() {
    super();
    this.state = {
      errorMessaged: "",
      errorMessage: "",
      successMessaged: "",
      successMessage: "",
      agent_email: auth.getEmail(),
      name: "",
      comp_name: "",
      title: "",
      email: "",
      password: "",
      errorEmail: false,
      errorPass: false,
      errorcPass: false,
      errorName: false,
      errorMessage: "",
      errorCompName: false,
      errorTitle: false,
      disabled: false,
      successMessage: "",
      confirm_password: "",
      errorConfirm: false,
      disableResendBtn: false,
      phone: "",
      errorPhone: false,
      fieldsHide: false,
      selected_roles: [],
      selected_sub_roles: [],
      main_role: "",
      sub_role: "",
      user_id: "",
      user_accountno: "",
      user_name: "",
      user_email: "",
      listSubRoleData: [],
      listPermissionRoles: [],
      listPermissionSubRoles: [],
      listPermissionData: [],
      roles_button: false,
      permissionErrorMsg: "",
      permissionSuccessMsg: "",
      subUserMenuTabs:
        localStorage.getItem("subUserMenuTabs") || "subadmin_menu",
      searchTerm: "",
    };
  }
  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };
  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    const savedTab = localStorage.getItem("subUserMenuTabs") || "subadmin_menu";
    this.setState({ subUserMenuTab: savedTab });

    let user_id = this.props.props.match.params.id;
    const servicesResponce = await listUserRoles(
      auth.getAccount(),
      auth.getToken(),
      user_id,
    );
    console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        selected_roles: servicesResponce.data.roles_rights,
        selected_sub_roles: servicesResponce.data.roles_rights_sub,
        tableLoader: false,
        user_id: user_id,
        user_accountno: servicesResponce.data.user_accountno,
        user_name: servicesResponce.data.name,
        user_email: servicesResponce.data.email,
      });
    } else {
      // window.location.replace("/error");
    }
    if (savedTab === "subadmin_permissions") {
      this.getSubUserPermissions();
    }
  }

  publishText = (value, tableMeta) => {
    let is_published = tableMeta.rowData[2];
    if (is_published === 1) {
      return "Yes";
    } else {
      return "No";
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });

    // Handle parent-child checkbox relationship
    if (name === "main_role") {
      const mainRoleId = parseInt(target.value);
      const isChecked = target.checked;

      // Find the current role data to get its sub-roles
      const currentRole = this.state.tableData.find(
        (role) => role.id === mainRoleId,
      );

      if (
        currentRole &&
        currentRole.subroles &&
        currentRole.subroles.length > 0
      ) {
        // Get all sub-role checkboxes for this main role
        currentRole.subroles.forEach((subrole) => {
          const subRoleCheckbox = document.querySelector(
            `input[value="${subrole.tabdetailid}"].vdrSelected2`,
          );
          if (subRoleCheckbox) {
            subRoleCheckbox.checked = isChecked;
          }
        });
      }
    }

    // console.log("handleChange: ", name + " " + value);
  };
  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ logo: event.target.files[0] });
  };

  formSave = async () => {
    this.scrollToTopJQuery();
    let { user_id } = this.state;
    var checkedValues = $("input:checkbox.vdrSelected:checked")
      .map(function () {
        return parseInt(this.value);
      })
      .get();
    // console.log("checkedValues: ", checkedValues);
    var checkedValuesSub = $("input:checkbox.vdrSelected2:checked")
      .map(function () {
        return parseInt(this.value);
      })
      .get();
    // console.log("checkedValuesSub: ", checkedValuesSub);
    this.setState({
      errorMessage: "",
      disabled: true,
    });

    const saveResponce = await addSubUserRoles(
      auth.getAccount(),
      auth.getToken(),
      user_id,
      JSON.stringify(checkedValues),
      JSON.stringify(checkedValuesSub),
    );
    // console.log("ADD ROLES RES: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (saveResponce.data.status === 404) {
      // window.location.replace("/error");
      this.setState({
        errorMessage: "There is some error while adding the roles.",
        successMessage: "",
        disabled: false,
      });
      this.clearMessagesAfterDelay();
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        successMessage: "Sub user roles added successfully.",
        disabled: false,
      });
      this.clearMessagesAfterDelay();
    } else {
      this.setState({
        errorMessage: "There is some error while adding the roles.",
        successMessage: "",
        disabled: false,
      });
      this.clearMessagesAfterDelay();
    }
  };

  handleChangeCheckbox = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
    //console.log("handleChange:", name + " " + value);
    //this.handlePercentage(name, value);
  };

  getChecked = async (role_id) => {
    let selected_roles = this.state.selected_roles;
    if (selected_roles.filter((e) => e.role_id === role_id).length > 0) {
      // console.log(role_id + " " + true);
      return true;
    }
    // console.log(role_id + " " + false);
    return false;
  };

  getCheckedsub = async (role_id) => {
    let selected_sub_roles = this.state.selected_sub_roles;

    if (
      selected_sub_roles.filter((item) => item.sub_role_id === role_id).length >
      0
    ) {
      return true;
    }

    return false;
  };

  clearMessagesAfterDelay = () => {
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 4000);
  };

  scrollToTopJQuery = () => {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500,
    );
  };

  getSubUserPermissions = async () => {
    const { user_accountno } = this.state;
    this.setState({
      tableLoader: true,
    });
    const listAgentSubRoleResponce = await listAssignedUserPermissions(
      auth.getAccount(),
      auth.getToken(),
      user_accountno,
    );

    console.log("getSubUserPermissions: ", listAgentSubRoleResponce.data);
    if (
      listAgentSubRoleResponce.data.status === 403 ||
      listAgentSubRoleResponce.data.errors === "authentication missing" ||
      listAgentSubRoleResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentSubRoleResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentSubRoleResponce.data.status === 200 &&
      listAgentSubRoleResponce.data.message === "success"
    ) {
      this.setState({
        listPermissionRoles: listAgentSubRoleResponce.data.roles,
        listPermissionSubRoles: listAgentSubRoleResponce.data.sub_roles,
        listPermissionData: listAgentSubRoleResponce.data.all_roles,
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  getAllRolesBySubRole = (subRoleName) => {
    const { listPermissionData } = this.state;
    const item = listPermissionData.find(
      (obj) => obj.sub_role_name === subRoleName,
    );

    if (!item) return [];

    try {
      const parsed = JSON.parse(item.all_roles);

      // ensure we always return an array
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("Invalid JSON in all_roles:", item.all_roles, e);
      return [];
    }
  };

  handleRoleChange = (subRoleName, roleValue, checked, role_title) => {
    this.setState((prevState) => {
      // Clone the listPermissionData
      const updatedList = prevState.listPermissionData.map((item) => {
        if (item.sub_role_name === subRoleName) {
          let rolesArray = [];

          try {
            rolesArray = JSON.parse(item.all_roles);
          } catch (e) {
            console.error("Invalid JSON in all_roles:", item.all_roles);
          }

          // Update the enabled value for the matching role
          const updatedRoles = rolesArray.map((role) =>
            role.value === roleValue
              ? { ...role, enabled: checked ? 1 : 0 }
              : role,
          );

          // Return updated object with new all_roles as JSON string
          return { ...item, all_roles: JSON.stringify(updatedRoles) };
        }
        return item;
      });

      return { listPermissionData: updatedList };
    });
  };

  add_user_permissions = async () => {
    const { listPermissionData, user_accountno } = this.state;
    this.scrollToTopJQuery();
    this.setState({
      roles_button: true,
      permissionErrorMsg: "",
      permissionSuccessMsg: "",
    });
    console.log("listPermissionData: ", listPermissionData);
    const listAgentSubRoleResponce = await updateAssignedUserPermissions(
      auth.getAccount(),
      auth.getToken(),
      JSON.stringify(listPermissionData),
      user_accountno,
    );

    console.log("add_user_permissions: ", listAgentSubRoleResponce.data);
    if (
      listAgentSubRoleResponce.data.status === 403 ||
      listAgentSubRoleResponce.data.errors === "authentication missing" ||
      listAgentSubRoleResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentSubRoleResponce.data.status === 404) {
      this.setState({
        roles_button: false,
        permissionErrorMsg:
          "There is some error while updating the permissions.",
        permissionSuccessMsg: "",
      });
      //window.location.replace("/error");
    } else if (
      listAgentSubRoleResponce.data.status === 200 &&
      listAgentSubRoleResponce.data.message === "success"
    ) {
      this.setState({
        roles_button: false,
        permissionErrorMsg: "",
        permissionSuccessMsg: "Permissions updated successfully.",
      });
      setTimeout(() => {
        this.setState({
          permissionSuccessMsg: "",
        });
        this.getSubUserPermissions();
      }, 4000);
    } else {
      this.setState({
        roles_button: false,
        permissionErrorMsg:
          "There is some error while updating the permissions.",
        permissionSuccessMsg: "",
      });
      //window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({
        roles_button: false,
        permissionErrorMsg: "",
        permissionSuccessMsg: "",
      });
    }, 4000);
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>

                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/sub_users")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Sub Users
                  </Link>
                  <Typography color="textPrimary" className="">
                    User Menu
                  </Typography>
                </Breadcrumbs>
                {/*<h3 className="nk-block-title page-title">
                  <PageTitle name="Add New Services" />
                </h3>*/}
                <div className="nk-block-des text-soft">
                  <ul className="list-inline">
                    <li>
                      User Name:{" "}
                      <span className="text-base">{this.state.user_name}</span>
                    </li>
                    <li>
                      User Email :{" "}
                      <span className="text-base">{this.state.user_email}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="nk-block">
            {/* Table 5th Col Start */}
            <div className="row g-gs">
              <div className="col-xxl-12">
                <div className="nk-block nk-block-lg">
                  <div className="card card-bordered">
                    <div className="card-inner">
                      {this.state.errorMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.subUserMenuTabs === "subadmin_menu"
                                ? "active"
                                : ""
                            }`}
                            data-toggle="tab"
                            href="#tabItem5"
                            onClick={() => {
                              this.setState({
                                subUserMenuTabs: "subadmin_menu",
                              });
                              localStorage.setItem(
                                "subUserMenuTabs",
                                "subadmin_menu",
                              );
                            }}
                          >
                            <em className="icon ni ni-grid-alt"></em>
                            <span>Sub User Menu</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.subUserMenuTabs ===
                              "subadmin_permissions"
                                ? "active"
                                : ""
                            }`}
                            data-toggle="tab"
                            href="#tabItem6"
                            onClick={() => {
                              this.setState({
                                subUserMenuTabs: "subadmin_permissions",
                              });
                              localStorage.setItem(
                                "subUserMenuTabs",
                                "subadmin_permissions",
                              );
                              this.getSubUserPermissions();
                            }}
                          >
                            <em className="icon ni ni-unlock"></em>
                            <span>Sub User Permissions</span>
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div
                          className={`tab-pane ${
                            this.state.subUserMenuTabs === "subadmin_menu"
                              ? "active"
                              : ""
                          }`}
                          id="tabItem5"
                        >
                          <form
                            method="post"
                            className="pageForm"
                            id="pageForm"
                          autoComplete="off"
                          role="presentation"
                          >
                            <div className="row g-4">
                              <div className="col-lg-12">
                                <div className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead
                                      style={{ borderTop: "1px solid #e5e9f2" }}
                                    >
                                      <tr>
                                        <th>Main Menu</th>
                                        <th>Sub Menu</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.tableData &&
                                      this.state.tableData.length > 0 ? (
                                        <>
                                          {this.state.tableData.map(
                                            (roles, idx) => (
                                              <tr key={`role${idx}`}>
                                                <td
                                                  style={{
                                                    width: "30%",
                                                    verticalAlign: "middle",
                                                  }}
                                                >
                                                  <div className="custom-control custom-checkbox">
                                                    <input
                                                      name="main_role"
                                                      type="checkbox"
                                                      className="custom-control-input vdrSelected"
                                                      id={`main_tab${idx}`}
                                                      value={roles.id}
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      defaultChecked={
                                                        this.state.selected_roles.filter(
                                                          (e) =>
                                                            e.role_id ===
                                                            roles.id,
                                                        ).length > 0
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={`main_tab${idx}`}
                                                    >
                                                      {roles.alt}
                                                    </label>
                                                  </div>
                                                </td>
                                                <td>
                                                  {roles.subroles &&
                                                  roles.subroles.length > 0 ? (
                                                    <>
                                                      {roles.subroles.map(
                                                        (subroles, ids) => (
                                                          <div
                                                            className="custom-control custom-checkbox"
                                                            key={`subrole${ids}`}
                                                            style={{
                                                              marginRight:
                                                                "25px",
                                                              marginBottom:
                                                                "15px",
                                                              marginTop: "10px",
                                                            }}
                                                          >
                                                            <input
                                                              name="sub_role"
                                                              type="checkbox"
                                                              className="custom-control-input vdrSelected2"
                                                              id={`sub_tab${idx}_${ids}`}
                                                              value={
                                                                subroles.tabdetailid
                                                              }
                                                              onChange={
                                                                this
                                                                  .handleChange
                                                              }
                                                              defaultChecked={
                                                                this.state.selected_sub_roles.filter(
                                                                  (e) =>
                                                                    e.sub_role_id ===
                                                                    subroles.tabdetailid,
                                                                ).length > 0
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                            <label
                                                              className="custom-control-label"
                                                              htmlFor={`sub_tab${idx}_${ids}`}
                                                            >
                                                              {subroles.alt}
                                                            </label>
                                                          </div>
                                                        ),
                                                      )}
                                                    </>
                                                  ) : null}
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                        </>
                                      ) : null}
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group text-right">
                                  <a
                                    onClick={() =>
                                      this.addMenuHistory("/sub_users")
                                    }
                                    className="btn btn-lg btn-light"
                                    disabled={this.state.disabled}
                                    style={{ marginRight: "15px" }}
                                  >
                                    <em className="icon ni ni-step-back"></em>
                                    Back
                                  </a>
                                  <button
                                    type="button"
                                    onClick={() => this.formSave()}
                                    className="btn btn-lg btn-primary"
                                    disabled={this.state.disabled}
                                  >
                                    Save User Roles
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div
                          className={`tab-pane ${
                            this.state.subUserMenuTabs ===
                            "subadmin_permissions"
                              ? "active"
                              : ""
                          }`}
                          id="tabItem6"
                        >
                          {this.state.tableLoader === true ? (
                            tableLoader()
                          ) : (
                            <>
                              <h5>User Permissions</h5>
                              <p>
                                The User Permissions module allows
                                administrators to control access to different
                                areas and features of the system for each
                                sub-user.
                              </p>
                              <div className="nk-block" id="rolesDiv">
                                {this.state.permissionErrorMsg &&
                                this.state.permissionErrorMsg !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.permissionErrorMsg}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.permissionSuccessMsg &&
                                this.state.permissionSuccessMsg !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>{this.state.permissionSuccessMsg}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="d-flex justify-content-end mb-2">
                                  {this.state.roles_button === false ? (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() =>
                                        this.add_user_permissions()
                                      }
                                      disabled={this.state.disabled}
                                    >
                                      Save Permissions
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      style={{ marginRight: "15px" }}
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em> Save
                                      Permissions
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  )}
                                </div>
                                <div className="row g-4">
                                  <div className="col-md-12 mb-4">
                                    <div className="form-group position-relative">
                                      <input
                                        type="text"
                                        className="form-control with-icon"
                                        placeholder="Search User Permission"
                                        value={this.state.searchTerm}
                                        onChange={(e) =>
                                          this.setState({
                                            searchTerm: e.target.value,
                                          })
                                        }
                                      />
                                      <em className="icon ni ni-search inside-icon"></em>
                                    </div>
                                  </div>
                                </div>
                                <table
                                  className="table table-bordered permissions-table"
                                  border="0"
                                >
                                  <thead>
                                    <tr>
                                      <th>Module / Sub-Module</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listPermissionRoles &&
                                    this.state.listPermissionRoles.length >
                                      0 ? (
                                      <>
                                        {this.state.listPermissionRoles
                                          .filter((roles) => {
                                            const term =
                                              this.state.searchTerm.toLowerCase();

                                            // Check if role_title matches OR if any sub_role matches
                                            const hasMatchingSub =
                                              this.state.listPermissionSubRoles.some(
                                                (sub) =>
                                                  sub.role_name ===
                                                    roles.role_name &&
                                                  sub.sub_role_title
                                                    .toLowerCase()
                                                    .includes(term),
                                              );

                                            return (
                                              roles.role_title
                                                .toLowerCase()
                                                .includes(term) ||
                                              hasMatchingSub ||
                                              term === ""
                                            );
                                          })
                                          .map((roles, idx) => (
                                            <>
                                              <tr key={`r-${idx}`}>
                                                <td
                                                  className="module-title"
                                                  style={{ width: "20%" }}
                                                >
                                                  {roles.role_title}
                                                </td>
                                                <td></td>
                                              </tr>
                                              {this.state
                                                .listPermissionSubRoles &&
                                              this.state.listPermissionSubRoles
                                                .length > 0 ? (
                                                <>
                                                  {this.state.listPermissionSubRoles
                                                    .filter(
                                                      (sub) =>
                                                        sub.role_name ===
                                                          roles.role_name &&
                                                        (sub.sub_role_title
                                                          .toLowerCase()
                                                          .includes(
                                                            this.state.searchTerm.toLowerCase(),
                                                          ) ||
                                                          roles.role_title
                                                            .toLowerCase()
                                                            .includes(
                                                              this.state.searchTerm.toLowerCase(),
                                                            ) ||
                                                          this.state
                                                            .searchTerm === ""),
                                                    ) // match role_name
                                                    .map((sub_roles, idx2) => {
                                                      const roleArray =
                                                        this.getAllRolesBySubRole(
                                                          sub_roles.sub_role_name,
                                                        );

                                                      return (
                                                        <tr key={`rs-${idx2}`}>
                                                          <td>
                                                            {
                                                              sub_roles.sub_role_title
                                                            }
                                                          </td>
                                                          <td>
                                                            <div className="row">
                                                              {Array.isArray(
                                                                roleArray,
                                                              ) &&
                                                              roleArray.length >
                                                                0 ? (
                                                                roleArray.map(
                                                                  (role, i) => (
                                                                    <div
                                                                      className="col-md-3"
                                                                      key={
                                                                        role.value ||
                                                                        `${idx2}-${i}`
                                                                      }
                                                                    >
                                                                      <div
                                                                        className="custom-control custom-checkbox"
                                                                        style={{
                                                                          marginRight:
                                                                            "25px",
                                                                          marginBottom:
                                                                            "7px",
                                                                          marginTop:
                                                                            "10px",
                                                                        }}
                                                                      >
                                                                        <input
                                                                          name="sub_role"
                                                                          type="checkbox"
                                                                          className="custom-control-input vdrSelected2"
                                                                          id={`chk_${sub_roles.sub_role_name}-${idx2}-${i}`}
                                                                          value={
                                                                            role.value
                                                                          }
                                                                          checked={
                                                                            role.enabled ===
                                                                            1
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            this.handleRoleChange(
                                                                              sub_roles.sub_role_name,
                                                                              role.value,
                                                                              e
                                                                                .target
                                                                                .checked,
                                                                              role.title,
                                                                            )
                                                                          }
                                                                        />
                                                                        <label
                                                                          className="custom-control-label"
                                                                          htmlFor={`chk_${sub_roles.sub_role_name}-${idx2}-${i}`}
                                                                        >
                                                                          {
                                                                            role.title
                                                                          }
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  ),
                                                                )
                                                              ) : (
                                                                <span>
                                                                  No roles
                                                                </span>
                                                              )}
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      );
                                                    })}
                                                </>
                                              ) : null}
                                            </>
                                          ))}
                                      </>
                                    ) : null}
                                  </tbody>
                                </table>
                                <div className="d-flex justify-content-end mt-4">
                                  {this.state.roles_button === false ? (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() =>
                                        this.add_user_permissions()
                                      }
                                      disabled={this.state.disabled}
                                    >
                                      Save Permissions
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      style={{ marginRight: "15px" }}
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em> Save
                                      Permissions
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Table 5th Col End */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Adduser);
